<template>
  <v-row class="mb-8">
    <v-col cols="12" v-show="!loading">
      <v-sheet
        outlined >
        <v-img
          class="image-banner"
          :src="url_banner"
          height="120px"
          v-if="url_banner"
        ></v-img>

        <v-row v-if="show_countdown && !show_activity" class="ma-0">
          <v-col cols="12">
            <v-card 
              class="pt-4 pb-4 card-activity"
              elevation="2"
              >
              <v-row>
                <v-col 
                  cols="12"
                  xl="4"
                  md="4"
                  sm="12"
                  v-if="activity.miniature"
                  class="pa-8">

                  <v-img
                    class="image-miniature"
                    :aspect-ratio="16/9"
                    :src="url_miniature"
                    fixed
                  ></v-img>

                  <pre>
                    {{ miniature }}
                  </pre>
                  
                </v-col>
                <v-col 
                  cols="12"
                  xl="8"
                  md="8"
                  sm="12" 
                  class="my-auto mx-auto white--text">
                  <h3 class="font-weight-regular text-center" ><b>{{ activity.name }}</b> comienza en</h3>
                  
                  <Countdown :date="end" @onFinish="finish()"></Countdown>
                  
                  <h5 
                    class="font-weight-regular text-center">
                    Si tiene problemas en acceder, hazlo desde nuestro canal de 
                    <a class="text-decoration-none white--text font-weight-bold" :href="activity.link_youtube" target="_blank">YouTube</a>
                  </h5>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="!show_countdown || show_activity" class="pa-4">
          <template v-if="activity.link_youtube">

            <v-col cols="12">
              
              <v-row style="height: 400px;">
                <v-col cols="12" xl="8" md="8" sm="12" style="display: flex;">
                  <LazyYoutube autoplay class="ma-0 video" :src="activity.link_youtube" />
                </v-col>
  
                <v-col
                  v-if="$vuetify.breakpoint.smAndUp" 
                  cols="12" xl="4" md="4" sm="12" class="section-chat mt-3 mb-3" style="display: flex;">
                  <chatAuditorium
                    :edition_id="edition.edition.id" 
                    :auditorium_slug="auditorium_slug"
                    :activity_slug="activity_slug"
                  />
                </v-col>
              </v-row>

              <v-row v-if="!$vuetify.breakpoint.smAndUp">
                <v-col cols="12">
                  <v-btn
                    block
                    @click="show_chat=true"
                    color="primary">
                    CHAT
                  </v-btn>
                </v-col>
                <v-divider></v-divider>
              </v-row>
              
              <v-row v-if="$vuetify.breakpoint.smAndUp" style="padding-top: 80px;">
                <v-divider></v-divider>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <h3>{{ activity.name }}</h3>
                  <label for="place">{{ activity.place }}</label>
                  <p class="text--secondary">{{ activity.description }}</p>
                  <label for="target_audience font-weight-bold">Público objetivo:</label>
                  <p class="text--secondary">{{ activity.target_audience }}</p>
                </v-col>
              </v-row>

            </v-col>
          </template>

          <template v-if="!activity.link_youtube">
            <v-row>
              <v-col>
                <h2 class="text-center pt-8 pb-8">
                  EL ADMINISTRADOR AÚN NO CONFIGURO EL AUDITORIO.
                </h2>
              </v-col>
            </v-row>
          </template>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="show_chat"
      max-width="560"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pt-8">

              <chatAuditorium
                    :edition_id="edition.edition.id" 
                    :auditorium_slug="auditorium_slug"
                    :activity_slug="activity_slug"
                  />

            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="show_chat = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { LazyYoutube } from "vue-lazytube" 
  import Countdown from "@/components/Countdown";
  import { DateTime } from 'luxon';
  import chatAuditorium from'@/components/auditorium/chatAuditorium'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showAuditorium',
    components: {
      Countdown, LazyYoutube, chatAuditorium
    },
    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      show_chat:false,

      drawer_chat:false,

      loading_activity: true,
      show_activity: false,
      show_countdown: false,

      activeChat: true,
      auditorium:[],
      activity:[],
      name:null,
      end:null,

      auditorium_slug:null,
      activity_slug:null,
      title:'AUDITORIO',

      data:[],

      entrepreneurship:[],

      banner:null,
      url_banner:null,

      banner_sm:null,
      url_banner_sm:null,

      miniature:null,
      url_miniature:null,
    }),
    computed: {
      ...mapGetters([
        'edition'
      ])
    },

    methods:{
      calcularAltura() {
        // Puedes calcular el height aquí según tus necesidades.
        // Por ejemplo, puedes obtener el alto de la ventana y restarle un valor fijo.
        const alturaVentana = window.innerHeight;
        const alturaFinal = alturaVentana - 100; // Ajusta el valor según tu necesidad.
        alert( `${alturaFinal}px` );
      },

      async getAuditorium(){
        await axios.get('participant/auditoriums/'+this.edition.edition.id+'/'+this.auditorium_slug+'/activity/'+this.activity_slug ).then(response =>{
          this.data = response.data.data
          this.auditorium = response.data.data.auditorium
          this.activity = response.data.data.activity

          this.show_countdown = response.data.data.activity.show_countdown

          let aux = this.activity.program.date+'T'+this.activity.start_time;
          let argentinaDateTime = DateTime.fromISO(aux, { zone: 'America/Argentina/Buenos_Aires' });
          this.end = argentinaDateTime.toJSDate();

          this.url_banner = APP_URL + this.auditorium.banner
          this.url_banner_sm = APP_URL + this.auditorium.banner_sm
          this.url_miniature = APP_URL + this.activity.miniature

          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      miFuncion(){
        this.loading = false
      },

      finish(){
        this.show_activity = true
      }
    },

    created(){
      this.auditorium_slug = this.$route.params.auditorium_slug;
      this.activity_slug = this.$route.params.activity_slug;
      this.getAuditorium()
    },
  }
</script>
<style scoped>
.card-activity {
  background: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}
.image-banner{
	position: relative;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}
.image-miniature{
	position: relative;
	width: 100%;
  border-radius: 4px;
  border: 2px solid #00a1b8;
  display: block;
}
.section-chat{
  width: 100%;
  background-size: cover;
  max-height: max-content;
  border-radius: 4px;
  border: 2px solid #00a1b8;
}
.video{
  max-width: 100%;
  z-index: 0;
  border: 2px solid #00a1b8;
  border-radius: 4px;
}
</style>